enum Rutas{
    EXPIRATION = 'expiration',
    BLOCKED = 'blocked',
    LOGIN = 'login',
    FORGOT_PASSWORD = 'forgotPassword',
    CHANGE_PASSWORD = 'passwordChange',
    DOUBLE_FACTOR = 'doublefactor',
    DOUBLE_FACTOR_LIST = 'listDoubleFactor',
    ADMINISTRATION = 'administration',
    ASSOCIATION = 'suite',
    DASHBOARD = 'dashboard',
    ERP_REGISTER = 'registro-erp',
    LIST_BUY = 'listadecompras',
    LIST_SELL = 'listadeventas',
    PRODUCT = 'product',
    PRODUCTS = 'products',
    MY_ACCOUNT = 'Misdatos',
    MY_COMPANIES = 'MisEmpresas',
    LIST_COMPANIES = 'listempre',
    SERVICE = 'servicio',
    PRODUCT_ACCESS = 'productaccess'
}

export enum RutasIframe{
    INFORMES_COMERCIALES='informes-comerciales',
    COMPRA_DE_CERTIFICADO_DIGITAL='compra-de-certificado-digital',
    FACTURADOR_MASIVO='facturador-masivo',
    SONDA='sonda',
    HERAMIENTAS_DE_GESTIÓN='heramientas-de-gestión',
    MI_CUENTA='mi-cuenta',
    FIRMA_DIGITAL='firma-digital',
    PORTAL_DE_PROVEEDORES='portal-de-proveedores',
    REPORTES_BI_VENTAS='reportes-bi-ventas',
    REPORTES_BI_CONTABILIDAD='reportes-bi-contabilidad',
    REPORTES_BI_FLUJO_CAJA='reportes-bi-flujo-caja',
    REPORTES_BI_INDICADORES_ECONOMICOS='reportes-bi-indicadores-economicos',
    REPORTES_BI_CLUSTERIZACIÓN_CLIENTES='reportes-bi-clusterización-clientes',
    ECOSISTEMA_DIGITAL='ecosistema-digital'

}

export default Rutas;
